import React from 'react';

function ChatIcon({ size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path d="M 1 19 L 19 1" fill="transparent" stroke="hsl(0, 0%, 100%)" />
      <path d="M 19 19 L 1 1" fill="transparent" stroke="hsl(0, 0%, 100%)" />
    </svg>
  );
}
ChatIcon.defaultProps = {
  size: 20,
};

export default ChatIcon;
